import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { runtimeApi, type RuntimeDashboard } from '../../api/moduleruntime';

const NAV = [
  { to: '/runtime/modules', label: 'Module Manager' },
  { to: '/runtime/installed', label: 'Installed' },
  { to: '/runtime/dependencies', label: 'Dependency Graph' },
  { to: '/runtime/health', label: 'Health' },
  { to: '/runtime/activity', label: 'Activity' },
  { to: '/runtime/upgrades', label: 'Upgrades' },
];

export function RuntimeHubPage() {
  const [dashboard, setDashboard] = useState<RuntimeDashboard | null>(null);
  const [error, setError] = useState('');

  useEffect(() => {
    void runtimeApi.dashboard().then(setDashboard).catch((e) => setError(String(e)));
  }, []);

  const stats = dashboard
    ? [
        { label: 'Total modules', value: dashboard.total_modules },
        { label: 'Installed', value: dashboard.installed_modules },
        { label: 'Enabled', value: dashboard.enabled_modules },
        { label: 'Running', value: dashboard.running_modules },
        { label: 'Healthy', value: dashboard.healthy_modules },
        { label: 'Errors', value: dashboard.error_modules },
      ]
    : [];

  return (
    <div className="mx-auto max-w-6xl p-6">
      <h1 className="text-2xl font-semibold">Enterprise Module Runtime</h1>
      <p className="mt-1 text-sm text-slate-600 dark:text-slate-400">
        Plug-and-play module lifecycle, registry, dependency resolution and hot reload.
      </p>
      <div className="mt-2 flex items-center gap-2 text-sm">
        <span className={`inline-block h-2 w-2 rounded-full ${dashboard?.runtime_healthy ? 'bg-emerald-500' : 'bg-red-500'}`} />
        <span>{dashboard?.runtime_healthy ? 'Runtime healthy' : 'Runtime degraded'}</span>
      </div>
      <nav className="mt-4 flex flex-wrap gap-3 text-sm">
        {NAV.map((l) => (
          <Link key={l.to} to={l.to} className="text-slate-700 hover:underline dark:text-slate-300">{l.label}</Link>
        ))}
      </nav>
      {error && <p className="mt-4 text-sm text-red-600">{error}</p>}
      <div className="mt-6 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {stats.map((s) => (
          <div key={s.label} className="rounded-xl border bg-white p-4 dark:border-slate-700 dark:bg-slate-900">
            <p className="text-sm text-slate-500 dark:text-slate-400">{s.label}</p>
            <p className="mt-1 text-2xl font-semibold">{String(s.value ?? 0)}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
